import { formatToTotal } from "utils/datetime-format-utils"

export function getStartDate(date: string) {
    const newDate = formatToTotal(new Date(date))
    return newDate.replaceAll(".", "")
}
